<template>
    <div class="stale-accounts-wrapper">
        <Row :gutter="32">
            <i-col :xs="12">
                <Table :columns="columns" :loading="dataLoading" :data="Trophies" :row-class-name="TrophyRowClassName"  @on-row-click="onTrophyRowClick">>
                    <div slot-scope="{ row, index }" slot="action">
                        <Button type="error" size="small" @click="deleteTrophy(row,index)">Delete</Button>
                    </div>
                </Table>
            </i-col>
            <i-col :xs="12">
                <div class="add-form">
                    <TrophyForm ref="trophyForm" @getTrophies="getTrophiesList" @setActive="setActive" :Trophies="Trophies"></TrophyForm>
                </div>
            </i-col>
        </Row>
    </div>
</template>

<script>
    import { bus } from "../../main";
    import { getTrophies,deleteTrophy } from "../../_services/trophy.service";
    import TrophyForm from "./TrophyForm"

    export default {
        data() {
            return {
                languages: [],
                selectedLanguage: null,
                activeTrophy:null,
                columns: [
                    {
                        title: "Existing Trophies",
                        key: "TrophyName",
                        className: "capitalize"
                    },
                    {
                        title: " ",
                        slot: "action",
                        width: 150,
                        align: "right"
                    }

                ],
                Trophies: [],
                dataLoading:true
            };
        },
        components:{
            TrophyForm
        },
        methods: {
            getTrophiesList(){
                getTrophies().then(async res=>{
                    this.Trophies=res.data.data
                    this.dataLoading=false
                }).catch(err=>{
                    bus.$emit('requestError',err)
                    this.dataLoading = false
                })
            },
            onTrophyRowClick(data,index){
                if(this.activeTrophy===index){
                    this.activeTrophy=null
                    this.$refs.trophyForm.resetForm()
                }else {
                    this.$refs.trophyForm.setUpdateData(data)
                }
            },
            TrophyRowClassName(row, index) {
                if (index === this.activeTrophy) {
                    return 'active-table-row';
                }
                return '';
            },
            async setActive(data){
                if(!data){
                    this.activeTrophy=null
                }else{
                    let vIndex = this.Trophies.map(function(e) { return e._id; }).indexOf(data._id);
                    if(vIndex===-1){
                        this.activeTrophy = null
                    }else {
                        this.activeTrophy = await vIndex
                    }
                }
            },
            deleteTrophy(data,index) {
                this.$Modal.confirm({
                    title: 'Remove Tropy',
                    content: "Are you sure you want to remove trophy?",
                    okText: 'Remove',
                    cancelText: 'Cancel',
                    onOk: () => {
                        this.dataLoading = true
                        deleteTrophy(data._id).then(res => {
                            this.Trophies.splice(index, 1);
                            this.dataLoading = false
                            this.unsetActive;
                            this.$refs.trophyForm.resetForm()
                            this.$Message.success(`Successfully deleted trophy ${data.TrophyName}!`);
                        }).catch(err => {
                            this.dataLoading = false
                            if(err.response.data.status===403){
                                this.$Message.error(err.response.data.message);
                            }else {
                                this.$Message.error("Failed to remove trophy. Please try again later.");
                            }
                        });
                    },
                });
            },
        },
        mounted() {
            this.getTrophiesList();
        }
    };
</script>
<style scoped>
    .stale-accounts-wrapper{
        width: 800px;
    }
    .remove-all{
        margin-top: 20px;
        float: right;
    }
</style>
